import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Optimize root creation
const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container, {
  // Enable concurrent features for better performance
  identifierPrefix: 'straton-'
});

// Render with performance optimizations
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Enable service worker for caching (if available)
if ('serviceWorker' in navigator && import.meta.env.PROD && false) { // Temporarily disabled
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        // Check for updates every 30 seconds
        setInterval(() => {
          registration.update();
        }, 30000);
        
        // Listen for new service worker
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New content available, force update
                newWorker.postMessage({ type: 'SKIP_WAITING' });
                window.location.reload();
              }
            });
          }
        });
      })
      .catch(() => {
        // Service worker registration failed, but app still works
      });
  });
}

// Force update check on app load
window.addEventListener('load', () => {
  // Check for updates every 30 seconds
  const checkForUpdates = () => {
    fetch(window.location.href, { 
      method: 'HEAD',
      cache: 'no-cache',
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache'
      }
    }).then(response => {
      const lastModified = response.headers.get('Last-Modified');
      const storedLastModified = localStorage.getItem('straton-last-modified');
      
      if (lastModified && storedLastModified && lastModified !== storedLastModified) {
        // New version detected, force reload
        localStorage.setItem('straton-last-modified', lastModified);
        window.location.reload(true);
      } else if (lastModified && !storedLastModified) {
        localStorage.setItem('straton-last-modified', lastModified);
      }
    }).catch(() => {
      // Ignore network errors
    });
  };
  
  // Check immediately and then every 30 seconds
  checkForUpdates();
  setInterval(checkForUpdates, 30000);
});
// Preload critical images
if ('requestIdleCallback' in window) {
  requestIdleCallback(() => {
    const criticalImages = [
      '/straton-ebook-cover.png'
    ];
    
    criticalImages.forEach(src => {
      const img = new Image();
      img.src = src;
    });
  });
}